import { Tube, Blob, Lathe, Bean } from "./shapes";

const LUNG = [[0.001, 0.105], [0.02, 0.095], [0.038, 0.06], [0.052, 0.01], [0.06, -0.04], [0.06, -0.075], [0.045, -0.095], [0.02, -0.088], [0.001, -0.08]];
const UTERUS = [[0.001, 0.032], [0.022, 0.028], [0.028, 0.012], [0.024, -0.008], [0.013, -0.026], [0.008, -0.04], [0.001, -0.042]];

const smallGut = () => {
  const pts = [];
  for (let row = 0; row < 6; row++) {
    const y = 1.035 - row * 0.017;
    const dir = row % 2 ? -1 : 1;
    for (let s = 0; s <= 6; s++) {
      const x = dir * (-0.05 + (s / 6) * 0.1);
      pts.push([x, y + Math.sin(s * 1.9) * 0.006, 0.065 + Math.cos(s * 1.3 + row) * 0.012]);
    }
  }
  return pts;
};
const SMALL_GUT = smallGut();

export const SHAPES = {
  brain: (m) => (
    <group>
      <Blob pos={[0.018, 1.7, 0.03]} r={[0.034, 0.05, 0.078]} bumps={38}>{m}</Blob>
      <Blob pos={[-0.018, 1.7, 0.03]} r={[0.034, 0.05, 0.078]} bumps={38}>{m}</Blob>
      <Blob pos={[0, 1.655, -0.025]} r={[0.045, 0.022, 0.03]} bumps={60}>{m}</Blob>
      <Tube pts={[[0, 1.66, 0.0], [0, 1.62, -0.005], [0, 1.58, -0.01]]} r={0.009}>{m}</Tube>
    </group>
  ),
  thyroid: (m) => (
    <group>
      <Blob pos={[0.017, 1.455, 0.058]} r={[0.01, 0.019, 0.009]} rot={[0, 0, -0.2]}>{m}</Blob>
      <Blob pos={[-0.017, 1.455, 0.058]} r={[0.01, 0.019, 0.009]} rot={[0, 0, 0.2]}>{m}</Blob>
      <Tube pts={[[-0.012, 1.448, 0.064], [0, 1.446, 0.068], [0.012, 1.448, 0.064]]} r={0.005}>{m}</Tube>
    </group>
  ),
  trachea: (m) => (
    <group>
      <Tube pts={[[0, 1.52, 0.045], [0, 1.43, 0.042], [0, 1.35, 0.035]]} r={0.0095}>{m}</Tube>
      <Tube pts={[[0, 1.35, 0.035], [0.02, 1.33, 0.03], [0.04, 1.305, 0.025]]} r={0.0075}>{m}</Tube>
      <Tube pts={[[0, 1.35, 0.035], [-0.02, 1.33, 0.03], [-0.042, 1.31, 0.025]]} r={0.0075}>{m}</Tube>
    </group>
  ),
  lungs: (m) => (
    <group>
      <Lathe pos={[0.07, 1.29, 0.02]} profile={LUNG} scale={[0.95, 1, 1.15]}>{m}</Lathe>
      <Lathe pos={[-0.072, 1.29, 0.02]} profile={LUNG} scale={[1.05, 1, 1.15]}>{m}</Lathe>
    </group>
  ),
  heart: (m) => (
    <group position={[0.02, 1.25, 0.065]} rotation={[0.2, 0, -0.45]}>
      <Blob pos={[0, 0.008, 0]} r={[0.038, 0.034, 0.032]}>{m}</Blob>
      <Lathe pos={[0.004, -0.018, 0]} profile={[[0.034, 0.012], [0.03, -0.02], [0.016, -0.045], [0.001, -0.055]]}>{m}</Lathe>
      <Tube pts={[[-0.005, 0.035, -0.005], [-0.01, 0.075, -0.01], [0.012, 0.09, -0.02], [0.03, 0.07, -0.03], [0.03, 0.02, -0.04]]} r={0.0085}>{m}</Tube>
      <Tube pts={[[0.012, 0.03, 0.012], [0.02, 0.06, 0.005], [0.035, 0.07, -0.01]]} r={0.0075}>{m}</Tube>
    </group>
  ),
  liver: (m) => (
    <group>
      <Blob pos={[-0.05, 1.16, 0.045]} r={[0.085, 0.045, 0.058]} rot={[0, 0, 0.28]}>{m}</Blob>
      <Blob pos={[0.035, 1.175, 0.055]} r={[0.05, 0.022, 0.04]} rot={[0, 0, -0.15]}>{m}</Blob>
    </group>
  ),
  stomach: (m) => (
    <group>
      <Tube pts={[[0.015, 1.21, 0.03], [0.045, 1.175, 0.055], [0.075, 1.15, 0.065], [0.075, 1.115, 0.072], [0.045, 1.095, 0.075], [0.005, 1.1, 0.07], [-0.02, 1.113, 0.06]]} r={0.022}>{m}</Tube>
      <Blob pos={[0.068, 1.168, 0.058]} r={[0.03, 0.03, 0.028]}>{m}</Blob>
    </group>
  ),
  gallbladder: (m) => <Blob pos={[-0.058, 1.118, 0.095]} r={[0.012, 0.022, 0.012]} rot={[0.4, 0, 0.4]}>{m}</Blob>,
  spleen: (m) => <Blob pos={[0.105, 1.155, 0.0]} r={[0.02, 0.042, 0.03]} rot={[0.3, 0, 0.35]}>{m}</Blob>,
  pancreas: (m) => <Tube pts={[[-0.035, 1.095, 0.04], [0.0, 1.105, 0.035], [0.04, 1.115, 0.025], [0.085, 1.13, 0.01]]} r={0.0105}>{m}</Tube>,
  kidneys: (m) => (
    <group>
      <Bean pos={[0.05, 1.085, -0.028]} rot={[0, 0, Math.PI * 0.43]}>{m}</Bean>
      <Bean pos={[-0.05, 1.075, -0.028]} rot={[0, Math.PI, Math.PI * 0.43]}>{m}</Bean>
      <Tube pts={[[0.045, 1.06, -0.02], [0.04, 0.98, -0.01], [0.02, 0.9, 0.05]]} r={0.0028}>{m}</Tube>
      <Tube pts={[[-0.045, 1.05, -0.02], [-0.04, 0.98, -0.01], [-0.02, 0.9, 0.05]]} r={0.0028}>{m}</Tube>
    </group>
  ),
  intestines: (m) => (
    <group>
      <Tube pts={[[-0.075, 0.945, 0.055], [-0.083, 1.0, 0.05], [-0.078, 1.055, 0.055], [-0.04, 1.07, 0.075], [0.04, 1.07, 0.075], [0.08, 1.06, 0.05], [0.084, 1.0, 0.045], [0.078, 0.94, 0.05], [0.045, 0.915, 0.065], [0.01, 0.905, 0.04], [0, 0.88, 0.0]]} r={0.016} seg={160}>{m}</Tube>
      <Tube pts={SMALL_GUT} r={0.0095} seg={400}>{m}</Tube>
    </group>
  ),
  appendix: (m) => <Tube pts={[[-0.072, 0.935, 0.06], [-0.068, 0.915, 0.07], [-0.075, 0.9, 0.065]]} r={0.0045}>{m}</Tube>,
  urethra: (m, sex) => (sex === "male"
    ? <Tube pts={[[0, 0.875, 0.066], [0, 0.855, 0.048], [0, 0.842, 0.068], [0, 0.855, 0.098], [0, 0.832, 0.126], [0, 0.806, 0.142]]} r={0.0035} seg={96}>{m}</Tube>
    : <Tube pts={[[0, 0.875, 0.068], [0, 0.856, 0.072], [0, 0.835, 0.078], [0, 0.818, 0.084]]} r={0.003}>{m}</Tube>),
  testicles: (m) => (
    <group>
      <Blob pos={[0.016, 0.832, 0.09]} r={[0.012, 0.016, 0.012]}>{m}</Blob>
      <Blob pos={[-0.016, 0.828, 0.088]} r={[0.012, 0.016, 0.012]}>{m}</Blob>
      <Tube pts={[[0.016, 0.846, 0.086], [0.03, 0.87, 0.07], [0.012, 0.87, 0.045], [0, 0.858, 0.045]]} r={0.002}>{m}</Tube>
      <Tube pts={[[-0.016, 0.842, 0.084], [-0.03, 0.87, 0.07], [-0.012, 0.87, 0.045], [0, 0.858, 0.045]]} r={0.002}>{m}</Tube>
    </group>
  ),
  vagina: (m) => <Tube pts={[[0, 0.895, 0.035], [0, 0.865, 0.045], [0, 0.838, 0.058], [0, 0.816, 0.07]]} r={0.009}>{m}</Tube>,
  bladder: (m) => <Blob pos={[0, 0.89, 0.068]} r={[0.03, 0.026, 0.027]}>{m}</Blob>,
  prostate: (m) => <Blob pos={[0, 0.855, 0.045]} r={[0.016, 0.013, 0.014]}>{m}</Blob>,
  uterus: (m) => (
    <group>
      <Lathe pos={[0, 0.925, 0.045]} profile={UTERUS} scale={[1, 1, 0.8]} rot={[0.35, 0, 0]}>{m}</Lathe>
      <Tube pts={[[0.02, 0.945, 0.05], [0.04, 0.955, 0.045], [0.055, 0.935, 0.045]]} r={0.003}>{m}</Tube>
      <Tube pts={[[-0.02, 0.945, 0.05], [-0.04, 0.955, 0.045], [-0.055, 0.935, 0.045]]} r={0.003}>{m}</Tube>
    </group>
  ),
  ovaries: (m) => (
    <group>
      <Blob pos={[0.055, 0.928, 0.045]} r={[0.011, 0.008, 0.009]}>{m}</Blob>
      <Blob pos={[-0.055, 0.928, 0.045]} r={[0.011, 0.008, 0.009]}>{m}</Blob>
    </group>
  ),
};
